import React from 'react';
import apiClient, { getAccessToken } from '../../apiClient';
import { withRouter } from 'react-router-dom';
import AddBoxIcon from "@material-ui/icons/AddBox";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import MaterialTable from '../../Components/DataTable/DataTable';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

class InventoryTransfer extends React.Component {
  state = {
    rows: [],
    itemOptions: [],
    locationList: [],
    historyRows: [],
    successMessage: null,
    errorMessage: null,
    submitting: false,
  };

  componentDidMount() {
    let user = JSON.parse(sessionStorage.getItem('user'));
    let accessToken = getAccessToken();
    apiClient.get('/api/get/item', {
      params: { forAutocomplete: 1, autocompleteEligible: 'active_inactive' },
      headers: { Authorization: `Bearer ${accessToken}` },
    }).then((res) => this.setState({ itemOptions: res.data || [] }));
    apiClient.get('/api/get/itemlocation', { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => this.setState({ locationList: res.data || [] }));
    this.loadHistory();

    if (user.permissions.filter((x) => x.PermissionName == 'Inventory' && x.PermissionAllowed == 1).length == 0) {
      const { history } = this.props;
      history.push('/home');
    }
  }

  loadHistory = () => {
    let accessToken = getAccessToken();
    apiClient.get('/api/get/inventorytransferhistory', { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => {
        const rows = Array.isArray(res.data)
          ? res.data
          : typeof res.data === 'string'
            ? JSON.parse(res.data || '[]')
            : [];
        this.setState({ historyRows: rows });
      })
      .catch(() => {
        this.setError('Could not load transfer history.');
      });
  };

  setError = (msg) => {
    this.setState({ errorMessage: msg });
    setTimeout(() => this.setState({ errorMessage: null }), 7000);
  };

  setSuccess = (msg) => {
    this.setState({ successMessage: msg });
    setTimeout(() => this.setState({ successMessage: null }), 3000);
  };

  fetchStockForRow = (rowIndex, itemId) => {
    if (!itemId || Number(itemId) <= 0) return;
    let accessToken = getAccessToken();
    apiClient.get('/api/get/itemlocationstock', {
      params: { itemId },
      headers: { Authorization: `Bearer ${accessToken}` },
    }).then((res) => {
      const opts = (res.data || []).map((x) => ({
        LocationId: Number(x.LocationId),
        LocationName: x.LocationName,
        Quantity: Number(x.Quantity) || 0,
      }));
      this.setState((prev) => {
        const rows = [...prev.rows];
        if (!rows[rowIndex]) return null;
        rows[rowIndex].fromLocationOptions = opts;
        const selectedFromId = Number(rows[rowIndex].fromLocationId || 0);
        const hit = opts.find((o) => o.LocationId === selectedFromId);
        rows[rowIndex].qtyAvailable = hit ? hit.Quantity : 0;
        return { rows };
      });
    });
  };

  handleAddRow = () => {
    this.setState((prev) => ({
      rows: [
        ...prev.rows,
        {
          id: prev.rows.length + 1,
          itemId: '',
          itemNumber: '',
          itemName: '',
          fromLocationId: '',
          qtyAvailable: 0,
          toLocationId: '',
          transferQty: '',
          fromLocationOptions: [],
        },
      ],
    }));
  };

  handleRemoveRow = (id) => {
    this.setState((prev) => ({ rows: prev.rows.filter((r) => r.id !== id) }));
  };

  handleItemSelect = (rowIndex, option) => {
    this.setState((prev) => {
      const rows = [...prev.rows];
      if (!rows[rowIndex]) return null;
      rows[rowIndex].itemId = option ? option.ItemId : '';
      rows[rowIndex].itemNumber = option ? option.ItemNumber : '';
      rows[rowIndex].itemName = option ? option.ItemName : '';
      rows[rowIndex].fromLocationId = '';
      rows[rowIndex].qtyAvailable = 0;
      rows[rowIndex].toLocationId = '';
      rows[rowIndex].transferQty = '';
      rows[rowIndex].fromLocationOptions = [];
      return { rows };
    }, () => {
      if (option && option.ItemId) {
        this.fetchStockForRow(rowIndex, option.ItemId);
      }
    });
  };

  handleRowField = (rowIndex, field, value) => {
    this.setState((prev) => {
      const rows = [...prev.rows];
      if (!rows[rowIndex]) return null;
      rows[rowIndex][field] = value;
      if (field === 'fromLocationId') {
        const hit = (rows[rowIndex].fromLocationOptions || []).find((o) => Number(o.LocationId) === Number(value));
        rows[rowIndex].qtyAvailable = hit ? hit.Quantity : 0;
      }
      return { rows };
    });
  };

  validateRows = () => {
    if (!this.state.rows.length) return 'Please add at least one transfer row.';
    const seen = new Set();
    for (let i = 0; i < this.state.rows.length; i++) {
      const r = this.state.rows[i];
      if (!r.itemId) return `Row ${i + 1}: Item Name is required.`;
      const itemKey = String(r.itemNumber || '').trim().toLowerCase();
      if (seen.has(itemKey)) return `Duplicate item number "${r.itemNumber}" is not allowed.`;
      seen.add(itemKey);
      if (!r.fromLocationId) return `Row ${i + 1}: Transfer from Location is required.`;
      if (!r.toLocationId) return `Row ${i + 1}: Transfer to Location is required.`;
      if (Number(r.fromLocationId) === Number(r.toLocationId)) return `Row ${i + 1}: Transfer from and to locations must be different.`;
      const tQty = Number(r.transferQty) || 0;
      if (!(tQty > 0)) return `Row ${i + 1}: Transfer Qty must be greater than zero.`;
      const available = Number(r.qtyAvailable) || 0;
      if (available <= 0 || tQty > available) {
        return 'Selected Item does not have sufficient qty in the” Transfer from Location”. Pls adjust the qty or use different item.';
      }
    }
    return null;
  };

  handleSubmit = () => {
    const err = this.validateRows();
    if (err) return this.setError(err);

    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user && user.accessToken ? user.accessToken : '';
    const payloadRows = this.state.rows.map((r) => ({
      itemId: r.itemId,
      itemNumber: r.itemNumber,
      itemName: r.itemName,
      fromLocationId: r.fromLocationId,
      toLocationId: r.toLocationId,
      transferQty: Number(r.transferQty) || 0,
    }));

    this.setState({ submitting: true });
    apiClient.post('/api/post/inventorytransfer', { userId: user.userId, rows: payloadRows }, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then(() => {
        this.setState({ rows: [], submitting: false });
        this.setSuccess('Inventory transfer submitted.');
        this.loadHistory();
      })
      .catch((e) => {
        const apiErr = e && e.response && e.response.data && e.response.data.error;
        this.setState({ submitting: false });
        this.setError(apiErr || 'Inventory transfer failed.');
      });
  };

  render() {
    return (
      <div className="ItemCategory">
        <h2>Inventory Transfer</h2>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <div className="alignDiv">
            <Button onClick={this.handleAddRow}>
              <AddBoxIcon />
              ADD TRANSFER
            </Button>
          </div>
        </div>

        <div style={{ marginTop: "10px" }}>
          <Table size="small" aria-label="inventory transfer table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Item Name</TableCell>
                <TableCell align="center">Transfer from Location</TableCell>
                <TableCell align="center">Qty</TableCell>
                <TableCell align="center">Transfer to Location</TableCell>
                <TableCell align="center">Transfer Qty</TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.rows.map((row, i) => (
                <TableRow key={`transfer-row-${row.id}`}>
                  <TableCell>
                    <Autocomplete
                      value={
                        this.state.itemOptions.find((x) => Number(x.ItemId) === Number(row.itemId)) || null
                      }
                      options={this.state.itemOptions}
                      getOptionLabel={(o) => `${o.ItemNumber || ''} - ${o.ItemName || ''}`}
                      onChange={(e, v) => this.handleItemSelect(i, v)}
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" placeholder="Item Number - Item Name" />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <FormControl fullWidth size="small">
                      <Select
                        value={row.fromLocationId}
                        onChange={(e) => this.handleRowField(i, 'fromLocationId', e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value=''>Select Location</MenuItem>
                        {(row.fromLocationOptions || []).map((loc) => (
                          <MenuItem key={`from-${row.id}-${loc.LocationId}`} value={loc.LocationId}>
                            {loc.LocationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell align="right">{Number(row.qtyAvailable || 0).toFixed(2)}</TableCell>
                  <TableCell>
                    <FormControl fullWidth size="small">
                      <Select
                        value={row.toLocationId}
                        onChange={(e) => this.handleRowField(i, 'toLocationId', e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value=''>Select Location</MenuItem>
                        {this.state.locationList
                          .filter((loc) => Number(loc.ItemLocationId) !== Number(row.fromLocationId || 0))
                          .map((loc) => (
                            <MenuItem key={`to-${row.id}-${loc.ItemLocationId}`} value={loc.ItemLocationId}>
                              {loc.LocationName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={row.transferQty}
                      onChange={(e) => this.handleRowField(i, 'transferQty', e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Button onClick={() => this.handleRemoveRow(row.id)}>
                      <DeleteOutlineIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <br />
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleSubmit}
            disabled={this.state.submitting}
          >
            {this.state.submitting ? 'Submitting…' : 'Submit'}
          </Button>

          {this.state.successMessage && (
            <div style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.successMessage}
            </div>
          )}
          {this.state.errorMessage && (
            <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          )}
        </div>

        <div style={{ maxWidth: '100%', paddingTop: '50px' }}>
          <MaterialTable
            title="Transfer History"
            columns={[
              { title: 'Item Name', field: 'ItemDisplay' },
              { title: 'Transfer from Location', field: 'FromLocationName' },
              { title: 'Qty', field: 'FromQty', render: (r) => Number(r.FromQty || 0).toFixed(2) },
              { title: 'Transfer to Location', field: 'ToLocationName' },
              { title: 'Transfer Qty', field: 'TransferQty', render: (r) => Number(r.TransferQty || 0).toFixed(2) },
              { title: 'User Name', field: 'UserName' },
              { title: 'Date Transfer', field: 'TransferDate' },
            ]}
            data={(this.state.historyRows || []).map((h) => ({
              ...h,
              ItemDisplay: `${h.ItemNumber || ''} - ${h.ItemName || ''}`,
            }))}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(InventoryTransfer);
